// export const URL = "https://supportapi.in-d.ai/";
// export const URL = "http://localhost:5000/";
export const URL = "https://api.intainft.com/";
// 
export const PATH = {
  contact: "user/contact",
  register: "user/register",
  intern: "user/intern",
  engineer: "user/newDev",
  login: "user/login",
  emailSubscribe: "user/subscribe",
  productsubscribe: "user/productsubscribe",
  medium: "user/medium-posts",
  getImage: "user/fetchimage/",
};
export const ADMINPATH = {
  addnews: "admin/addnews",
  displaynews: "admin/displaynews",
  editnews: "admin/editnews",
  deletenews: "admin/deletenews",
  addevents: "admin/addevents",
  displayevents: "admin/displayevents",
  editevents: "admin/editevents",
  deleteevents: "admin/deleteevents",
  getRecentActivities: "admin/activities",
  getTotalUsers: "admin/totalusers",

};
